export enum AdminRoleEnum {
    SUPER_ADMIN = 1,
    CMU_ADMIN = 2,
}